import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TiktokUserHashtagPostList.graphql';
import { Query, QuerytiktokUserHashtagPostListArgs } from '../../__generated__/globalTypes';

export const useTiktokUserHashtagPostListQuery = (
  options?: QueryHookOptions<Query, QuerytiktokUserHashtagPostListArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytiktokUserHashtagPostListArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTiktokUserHashtagPostListLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytiktokUserHashtagPostListArgs>
): QueryResult<Query, QuerytiktokUserHashtagPostListArgs> & {
  getTiktokUserHashtagPostList: LazyQueryExecFunction<Query, QuerytiktokUserHashtagPostListArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTiktokUserHashtagPostList, result] = useLazyQuery<Query, QuerytiktokUserHashtagPostListArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getTiktokUserHashtagPostList, ...result };
};

export const useTiktokUserHashtagPostListPromiseQuery = () => {
  const client = useApolloClient();

  const getTiktokUserHashtagPostList = useCallback(
    (options?: Omit<QueryOptions<QuerytiktokUserHashtagPostListArgs, Query>, 'query'>) =>
      client.query<Query, QuerytiktokUserHashtagPostListArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getTiktokUserHashtagPostList };
};
// Suspense Query Hooks
export const useTiktokUserHashtagPostListSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerytiktokUserHashtagPostListArgs>
) => {
  const result = useSuspenseQuery<Query, QuerytiktokUserHashtagPostListArgs>(QUERY, {
    ...options
  });

  return result;
};
